import { imageDatabaseCategoryCollection } from "@/firebase";

const state = {
  imageDatabaseCategory: [],
};

const getters = {};

const actions = {
  getImageDatabaseCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.mode == "live") {
        imageDatabaseCategoryCollection
          .where("client", "in", ['/', payload.client])
          .where("type", "==", payload.type)
          .where("active", "==", true)
          .orderBy("order", "asc")
          .orderBy("title", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            resolve(commit("getImageDatabaseCategory", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
      } else
        imageDatabaseCategoryCollection
          .where("client", "in", ['/', payload.client])
          .where("type", "==", payload.type)
          .orderBy("order", "asc")
          .orderBy("title", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            // če potrebujemo "reset kategorije", dodamo še to opcijo v state
            if (payload.addEmptyCat) tempData.push({ client: "/", active: true, id: "", order: 1000, title: payload.addEmptyCat, type: payload.type });

            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            resolve(commit("getImageDatabaseCategory", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
    });
  },
  addImageDatabaseCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order); // String => Number

      imageDatabaseCategoryCollection
        .add(payload)
        .then((docRef) => {
          //console.log("Added record.");
          resolve(
            commit(
              "addImageDatabaseCategory",
              Object.assign(payload, { id: docRef.id })
            )
          );
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  removeImageDatabaseCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      imageDatabaseCategoryCollection
        .doc(payload)
        .delete()
        .then(() => {
          resolve(commit("removeImageDatabaseCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  editImageDatabaseCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order); // String => Number

      imageDatabaseCategoryCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editImageDatabaseCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
};

const mutations = {
  getImageDatabaseCategory(state, payload) {
    state.imageDatabaseCategory = payload;
    console.log(state.imageDatabaseCategory);
  },
  addImageDatabaseCategory(state, payload) {
    state.imageDatabaseCategory.push(payload);
  },
  removeImageDatabaseCategory(state, payload) {
    const index = state.imageDatabaseCategory.findIndex((item) => item.id == payload);
    state.imageDatabaseCategory.splice(index, 1);
  },
  editImageDatabaseCategory(state, payload) {
    const index = state.imageDatabaseCategory.findIndex((item) => item.id == payload.id);
    state.imageDatabaseCategory.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
